import {SearchCriteriaConfig} from '../../../page-components/common/search-criteria/type/search-criteria.type';

export const searchCriteria: SearchCriteriaConfig[] = [
    {
        key : 'duration',
        label:'Duration',
        inputType:'date-range'
    },
    {
        key: 'roles',
        label: 'Role',
        inputType: 'select',
        placeholder:"Select role",
        options: [
            {value: 'ADMIN', label: 'Admin'},
            {value: 'EMPLOYEE', label: 'Employee'},
            {value: 'USER', label: 'User'},
        ]
    },
];